import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import Channel from "ui/common/channel/Channel";
import { focusChannel } from "actions/ui";
import Customize from "ui/common/customize/Customize";
import Column from "../components/Column";
import NoChannelColumn from "./NoChannelColumn";
import CloseButton from "ui/common/channel/components/CloseButton";
import StreamStatus from "ui/common/channel/components/streams/StreamStatus";

class WindowsController extends React.Component {

	constructor(props) {
		super(props);

		this.handleWindowClick = this.handleWindowClick.bind(this);
	}

	handleWindowClick(channel) {
		this.props.focusChannel(channel.id);
	}

	getOpenedChannels() {
		return this.props.openedChannels
			.filter( channelId => this.props.channels.find( channel => channel.id === channelId && (this.props.configuration.interface.chat.publicEnabled || channel.type === 'direct')) )
			.map( channelId => this.props.channels.find( channel => channel.id === channelId) );
	}

	render() {
		const openedChannels = this.getOpenedChannels();

		return(
			<React.Fragment>
				{ openedChannels.map( (channel, index) =>
					<Column
						key={ index }
						id={ channel.id }
						title={ this.props.configuration.interface.channel.direct.title ? this.props.configuration.interface.channel.direct.title : channel.name }
						className={ channel.id === this.props.focusedChannel ? ' wcFocused' : '' }
						unread={ this.props.channelsUi[channel.id] && this.props.channelsUi[channel.id].unread > 0 }
						closable={ this.props.publicChannels.length > 1 || channel.type === 'direct' }
						closeButton={ <CloseButton channel={ channel } focusOnClose={ true } className="wcFunctional wcClose" /> }
						onClick={ e => this.handleWindowClick(channel) }
						contentClassName="wcChannelContent"
						headerContentElements={ [ <StreamStatus key={ channel.id } channel={ channel } /> ] }
					>
						<Channel
							channel={ channel }
							className={ this.props.minimizedChannels.includes(channel.id) ? 'wcInvisible' : undefined }
						/>
						{!this.props.configuration.interface.browser.enabled && index === 0 && !this.props.minimizedChannels.includes(channel.id) &&
							<Customize />
						}
					</Column>
				)}

				{openedChannels.length === 0 && !this.props.configuration.interface.browser.enabled &&
					<NoChannelColumn/>
				}
			</React.Fragment>
		)
	}

}

WindowsController.propTypes = {
	configuration: PropTypes.object.isRequired
};

export default connect(
	(state) => ({
		i18n: state.application.i18n,
		i18nBase: state.configuration.i18n,
		configuration: state.configuration,
		publicChannels: state.application.channels.filter( channel => channel.type !== 'direct' ),
		channels: state.application.channels,
		focusedChannel: state.ui.focusedChannel,
		openedChannels: state.ui.openedChannels,
		minimizedChannels: state.ui.minimizedChannels,
		channelsUi: state.ui.channels
	}),
	{ focusChannel }
)(WindowsController);